module.exports = __webpack_public_path__ + "assets/many.cde866d25f2d82b63463213919d4b6a6.png";